import { Link } from "react-router-dom";
import classNames from "./Breadcrumbs.module.css";
import React from "react";

const Breadcrumbs = (props: { items: { label: string; url: string }[] }) => {
  return (
    <nav aria-label="breadcrumbs" className={classNames.Breadcrumbs}>
      {props.items.map((item, index) => (
        <React.Fragment key={index}>
          {index !== 0 && index !== props.items.length && <span>{"/"}</span>}
          <Link to={item.url}>{item.label}</Link>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
